<template>
  <div class="splash-screen">
    <v-container fluid class="h-100">
      <v-row align="center" justify="center" class="h-100">
        <v-col cols="12" class="d-flex flex-column justify-center align-center">
          <div class="mb-4" style="width: 400px; height: 300px;">
            <v-img 
              :src="loadingImage" 
              alt="Loading"
              width="400"
              height="300"
              contain
              eager
            />
          </div>
          <p class="text-grey font-weight-regular">
            Just a moment
          </p>
          <h2 style="color: #141414;" class="primary--font font-weight-regular mt-4 mb-4">Preparing an optimised workspace for you</h2>
          <div class="w-50 mt-6">
            <v-progress-linear
              color="blue-darken-1"
              height="6"
              indeterminate
              rounded
            ></v-progress-linear>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import loadingImage from '@/assets/images/explore/loading-image.svg'
</script>

<style scoped>
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #fff;
  z-index: 9999;
}




@media (prefers-color-scheme: dark) {
  .splash-screen {
    background: white
  }
}
</style>

